import { Point2D } from "types/geometry";

export const point2DToLatLng = (point: Point2D) => ({ lat: point.y, lng: point.x });

export const latLngToPoint2D = ({ lat, lng }: { lat: number; lng: number }): Point2D => ({
    x: lng,
    y: lat,
});
